import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=307722f6"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307722f6')) {
      api.createRecord('307722f6', component.options)
    } else {
      api.reload('307722f6', component.options)
    }
    module.hot.accept("./ErrorList.vue?vue&type=template&id=307722f6", function () {
      api.rerender('307722f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/crud-components/ErrorList.vue"
export default component.exports